import { render } from "./PaymentDemo.vue?vue&type=template&id=43eb5dee"
import script from "./PaymentDemo.vue?vue&type=script&lang=js"
export * from "./PaymentDemo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/chatbot_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__